import styles from "./InformationSystemsAcceptableUsePolicyPage.module.css";

const InformationSystemsAcceptableUsePolicyPage = () => {
  return (
    <div className={styles.container}>
      <h1>Πολιτική Αποδεκτής Χρήσης Πληροφοριακών Συστημάτων</h1>
      <h2>1. Εισαγωγή</h2>
      <p>
        Ο Γενικός Κανονισμός Προστασίας Δεδομένων (ΕΕ/2016/679) ισχύει από τις
        25 Μαΐου 2018 (εφεξής "ΓΚΠΔ"). Ο ΓΚΠΔ προβλέπει δικαιώματα, τα οποία
        απολαμβάνουν τα υποκείμενα των δεδομένων, και υποχρεώσεις για όλα τα
        μέρη που εμπλέκονται σε δραστηριότητες επεξεργασίας δεδομένων, ενώ τα
        πρόστιμα αυξάνονται έως και 20 εκατομμύρια ευρώ ή το 4% των ετήσιων
        εσόδων μιας εταιρείας ή ενός οργανισμού, ανάλογα με το ποιο είναι
        μεγαλύτερο.
      </p>
      <p>
        Η προστασία των προσωπικών δεδομένων είναι πολύ σημαντική για την
        εταιρεία μας με την επωνυμία «THE RECORDS HUB Α.Ε.» και το διακριτικό
        τίτλο «THE RECORDS HUB», που εδρεύει στη Κορωπί, θέση Κόντι, οδός Αιγέα
        αρ. 64, με Α.Φ.Μ. 800897289, Δ.Ο.Υ. ΦΑΕ Αθηνών, νομίμως εκπροσωπούμενη
        για την υπογραφή του παρόντος από τον Πρόεδρο και Διευθύνοντα Σύμβουλο
        της κ. Ανδρέα Γεωργίου, εφεξής καλούμενη η «Εταιρεία».
      </p>
      <p>
        Διασφαλίζουμε την πλήρη συμμόρφωση με το ισχύον Νομικό Πλαίσιο
        Προστασίας Δεδομένων, συμπεριλαμβανομένου του Γενικού Κανονισμού
        Προστασίας Δεδομένων (ΓΚΠΔ) και του νόμου 4624/2019, και επεξεργαζόμαστε
        τα προσωπικά δεδομένα σύμφωνα με τις ισχύουσες βασικές αρχές.
      </p>
      <p>
        Η εταιρεία επεξεργάζεται τα περισσότερα προσωπικά δεδομένα με ψηφιακά
        μέσα. Ως εκ τούτου, φιλοδοξεί να εφαρμόζει τα πλέον κατάλληλα τεχνικά
        και οργανωτικά μέτρα για την προστασία του χρησιμοποιούμενου υλικού
        (hardware) και λογισμικού (software), καθώς και για την προστασία των
        δεδομένων.
      </p>
      <h2>2. Σκοπός</h2>
      <p>
        Η παρούσα πολιτική σκοπεύει να βοηθήσει την εταιρεία να αντιμετωπίσει
        τους κινδύνους που σχετίζονται με την επεξεργασία των δεδομένων που
        αναφέρονται παραπάνω. Καθορίζει τα οργανωτικά πρότυπα, τις διαδικασίες
        και τα όρια για τους χρήστες. Καθορίζει επίσης τις υποχρεώσεις των
        χρηστών, συμπεριλαμβανομένων των απαιτούμενων ενεργειών σε περίπτωση
        απώλειας.
      </p>
      <p>
        Η παρούσα πολιτική φιλοδοξεί να διασφαλίσει ότι κάθε πληροφορία που
        επεξεργάζεται η εταιρεία προστατεύεται από μη εξουσιοδοτημένη πρόσβαση,
        τροποποίηση και διαγραφή.
      </p>
      <p>
        Οι συνεργάτες της εταιρείας, ανεξαρτήτως της συμβατικής τους σχέσης με
        αυτή, πρέπει να συμμορφώνονται με την Πολιτική αυτή και να αναφέρουν
        κάθε παραβίασή της που μπορεί να αντιληφθούν στον άμεσο προϊστάμενό τους
        ή στην Υπεύθυνη Προστασίας Δεδομένων.
      </p>
      <p>
        Οι συνεργάτες της εταιρείας μπορούν να απευθυνθούν στον άμεσα
        προϊστάμενό τους, για ερωτήσεις ως προς την εφαρμογή της Πολιτικής. Οι
        προϊστάμενοι μπορούν να απευθυνθούν στην Υπεύθυνη Προστασίας Δεδομένων ή
        στον Πρόεδρο και Διευθύνων Σύμβουλο της εταιρείας.
      </p>
      <h2>3. Πεδίο Εφαρμογής</h2>
      <p>
        Η παρούσα Πολιτική ισχύει για όλους τους συνεργάτες της εταιρείας που
        χρησιμοποιούν υλικό ή/και λογισμικό που ανήκει στην εταιρεία και τους
        παρέχεται στο πλαίσιο του ρόλου τους.
      </p>
      <p>
        Η παρούσα Πολιτική ισχύει για όλο το υλικό και το λογισμικό που παρέχει
        η εταιρεία για τις δραστηριότητές της, καθώς και για κάθε προσωπικό
        υλικό που σχετίζεται με τις δραστηριότητες της.
      </p>
      <h2>4. Πιθανοί Κίνδυνοι</h2>
      <p>
        Οι πιθανοί κίνδυνοι για τα δεδομένα που επεξεργάζεται η εταιρεία είναι
        πολυάριθμοι. Περιλαμβάνουν, μεταξύ άλλων, τα εξής:
      </p>
      <h3>Απώλεια δεδομένων</h3>
      <p>
        Πιθανή απώλεια ή κλοπή μπορεί να οδηγήσει σε απώλεια, αλλοίωση και μη
        εξουσιοδοτημένη πρόσβαση τρίτων στα δεδομένα. Έτσι, ενδέχεται να
        παραβιάζονται τα δικαιώματα των υποκειμένων των δεδομένων, τα οποία
        διατηρούν τα δεδομένα τους στο εν λόγω υλικό και λογισμικό.
      </p>
      <h3>Επιθέσεις που αφορούν κακόβουλο λογισμικό</h3>
      <p>
        Η χρήση φορητών συσκευών σε άλλα δίκτυα (π.χ. σε τρίτο δίκτυο, στο
        σπίτι) μπορεί να αυξήσει τον κίνδυνο επιθέσεων που αφορούν κακόβουλο
        λογισμικό.
      </p>
      <h3>Διαρροή πληροφοριών</h3>
      <p>
        Ορισμένες συσκευές διατηρούν πληροφορίες μετά τη διαγραφή τους από τον
        χρήστη. Αυτό μπορεί να οδηγήσει σε μη εξουσιοδοτημένη διαβίβαση
        πληροφοριών ή πρόσβαση από τρίτους.
      </p>
      <h3>Βλάβη της φήμης</h3>
      <p>
        Η διαρροή πληροφοριών μπορεί να εγείρει την προσοχή των μέσων ενημέρωσης
        και των πελατών. Αυτό μπορεί να οδηγήσει σε ζημία φήμης, τόσο για το
        υποκείμενο των δεδομένων όσο και για την εταιρεία.
      </p>
      <h3>Οικονομική ζημία</h3>
      <p>
        Εκτός από την άμεση οικονομική ζημία, μια παραβίαση δεδομένων μπορεί να
        οδηγήσει σε πρόστιμα και αγωγές.
      </p>
      <h2>5.Πολιτική Αποδεκτής Χρήσης</h2>
      <h3>5.1 Τεχνικά μέτρα</h3>
      <p>
        Ο Πρόεδρος και Διευθύνων Σύμβουλος της εταιρείας μας σε συνεργασία με
        τους τεχνικούς συμβούλους της εταιρείας μας διασφαλίζουν ότι
        εφαρμόζονται πάντοτε τουλάχιστον τα ακόλουθα μέτρα:
      </p>
      <p>
        1) Σε όλες τις συσκευές που χρησιμοποιούνται για τις λειτουργίες της
        εταιρείας και την επεξεργασία δεδομένων προσωπικού χαρακτήρα εφαρμόζεται
        πάντοτε κατάλληλο και ενημερωμένο λογισμικό προστασίας από ιούς.
      </p>
      <p>
        2) Λαμβάνονται αντίγραφα ασφαλείας σε διαφορετική τοποθεσία από την
        κύρια τοποθεσία των δεδομένων.
      </p>
      <p>3) Οι συσκευές της εταιρείας είναι κρυπτογραφημένες.</p>
      <p>
        4) Οι συσκευές της εταιρείας προστατεύονται από ισχυρούς κωδικούς
        πρόσβασης, οι οποίοι υπόκεινται σε αυστηρή πολιτική κωδικών πρόσβασης.
      </p>
      <p>
        5) Η εταιρεία παρέχει στους εργαζομένους εταιρικές διευθύνσεις
        ηλεκτρονικού ταχυδρομείου και πρόσβαση στο λογισμικό της εταιρείας, με
        βάση τον ρόλο του κάθε εργαζομένου στην εταιρεία.
      </p>
      <p>
        6) Όλες οι επικοινωνίες της εταιρείας πραγματοποιούνται μέσω εταιρικών
        e- mails, εφαρμόζοντας όλα τα μέτρα ασφαλείας. Σελίδα 4 από 6
      </p>
      <p>
        7) Επιτρέπεται η χρήση μόνο ειδικά εξουσιοδοτημένων φορητών μέσων
        αποθήκευσης στους υπολογιστές της εταιρείας.
      </p>
      <h3>5.2 Οργανωτικά μέτρα</h3>
      <p>
        Οι συνεργάτες της εταιρείας, που έχουν πρόσβαση στο λογισμικό ή/και το
        υλικό της εταιρείας μας και είναι υπεύθυνοι:
      </p>
      <p>
        1) Να αντιμετωπίζουν με απόλυτη εμπιστευτικότητα κάθε πληροφορία στην
        οποία έχουν πρόσβαση στο πλαίσιο του ρόλου τους στην εταιρεία.
      </p>
      <p>
        2) Να χρησιμοποιούν υπεύθυνα και να προστατεύουν τα διαπιστευτήρια που
        τους παρέχει η εταιρεία για τη χρήση του υλικού και του λογισμικού.
      </p>

      <p>
        3) Να διασφαλίζουν ότι το λογισμικό και το υλικό της εταιρείας
        χρησιμοποιείται αποκλειστικά από αυτούς.
      </p>
      <p>
        4) Να διασφαλίζουν ότι το λογισμικό και το υλικό της εταιρείας
        χρησιμοποιείται αποκλειστικά για τους σκοπούς της εταιρείας και σύμφωνα
        με τις κατευθυντήριες γραμμές και τις διαδικασίες της εταιρείας.{" "}
      </p>
      <p>
        5) Να μην χρησιμοποιούν τα διαπιστευτήρια ή/και το όνομα οποιουδήποτε
        άλλου συνεργάτη της εταιρείας.
      </p>
      <p>
        6) Να μη χρησιμοποιούν προσωπικές συσκευές στο πλαίσιο του ρόλου τους,
        εάν δεν έχουν λάβει προηγούμενη γραπτή έγκριση από την Διευθύντρια ή
        άλλο αρμόδιο όργανο, και φροντίζουν ιδιαίτερα να διασφαλίζουν το μέγιστο
        επίπεδο ασφάλειας για τις συσκευές αυτές.
      </p>
      <p>
        7) Να μην επιχειρούν να αποκτήσουν πρόσβαση σε δεδομένα στα οποία δεν
        δικαιούνται να έχουν πρόσβαση.
      </p>
      <p>
        8) Να προστατεύουν κάθε δεδομένο που λαμβάνουν, αποστέλλουν, αποθηκεύουν
        και με οποιονδήποτε τρόπο επεξεργάζονται, σύμφωνα με τον ρόλο τους στην
        εταιρεία.{" "}
      </p>
      <p>
        9) Να διασφαλίζουν ότι αποστέλλουν δεδομένα μόνο σε παραλήπτες που
        πρέπει να έχουν πρόσβαση στα δεδομένα, δίνοντας ιδιαίτερη προσοχή στην
        αποστολή των δεδομένων στη σωστή διεύθυνση κάθε παραλήπτη (είτε
        εσωτερικού είτε εξωτερικού).
      </p>
      <p>
        10) Να διασφαλίζουν ότι δεν ελέγχονται ή παρακολουθούνται από τρίτους
        κατά τη διάρκεια της εργασίας τους. Σελίδα 5 από 6
      </p>
      <p>
        11) Να διασφαλίζουν ότι δεν αφήνουν τις συσκευές τους που
        χρησιμοποιούνται για εταιρικούς σκοπούς αφύλακτες και ξεκλείδωτες.
      </p>
      <p>
        12) Να διασφαλίζουν ότι όλα τα προσωπικά δεδομένα που επεξεργάζονται
        είναι πάντα διαθέσιμα και ασφαλή.
      </p>
      <p>
        13) Να ενημερώνουν αμέσως, σύμφωνα με την Πολιτική Διαχείρισης
        Περιστατικού Παραβίασης Δεδομένων, σε περίπτωση που αντιληφθούν
        παραβίαση της ασφάλειας.
      </p>
      <p>
        14)Να μην επιχειρούν να παρακάμψουν την ασφάλεια του λογισμικού και του
        υλικού της εταιρείας.
      </p>
      <p>
        15) Να μην εγκαθιστούν ιούς και κακόβουλο λογισμικό στο λογισμικό και το
        υλικό της εταιρείας.
      </p>
      <p>
        16) Να μην απενεργοποιούν τα μέτρα ασφαλείας που λαμβάνει η εταιρεία,
        συμπεριλαμβανομένης της προστασίας από ιούς.
      </p>
      <p>
        17) Να μην εγκαθιστούν ή απεγκαθιστούν οποιοδήποτε λογισμικό στο υλικό
        της εταιρείας, χωρίς να έχουν λάβει γραπτή έγκριση.
      </p>
      <p>
        18) Να ενημερώνουν κατάλληλα σχετικά με κάθε σημαντική πληροφορία που
        είναι αποθηκευμένη στο λογισμικό και το υλικό της εταιρείας, κατά τη
        λήξη της σχέσης τους με την εταιρεία.
      </p>
      <p>
        19) Να επιστρέφουν κάθε λογισμικό και υλικό που τους παρέχεται από την
        εταιρεία, κατά τη λήξη της σχέσης τους.
      </p>
      <h2>6. Αναθεώρηση Πολιτικής</h2>
      <p>
        Η Υπεύθυνη Προστασίας Δεδομένων, σε συνεργασία με τον Πρόεδρο και
        Διευθύνοντα Σύμβουλο της εταιρείας και τους τεχνικούς συμβούλους, θα
        πρέπει να εξετάζει περιοδικά και να ανανεώνει αυτή την Πολιτική όταν
        κρίνεται απαραίτητο.{" "}
      </p>
    </div>
  );
};

export default InformationSystemsAcceptableUsePolicyPage;
